import { render } from "./FormPhone.vue?vue&type=template&id=743d0d14&scoped=true"
import script from "./FormPhone.vue?vue&type=script&lang=js"
export * from "./FormPhone.vue?vue&type=script&lang=js"

import "./FormPhone.vue?vue&type=style&index=0&id=743d0d14&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743d0d14"]])

export default __exports__